// Montessori
import React from 'react';
import NationalSportsDay2025  from 'views/NationalSportsDay2025';

const Montessoripage = () => {
  return <NationalSportsDay2025/>;
};

export default Montessoripage;